/* VRENT Bento interactions: scroll progress, header state, count-up, locale link guard, mobile CTA, product sales module. */
(function(){
  'use strict';
  var LANG=(document.documentElement.lang||'en').slice(0,2);
  if(!/^(de|fr|it)$/.test(LANG)) LANG='en';
  var LP = LANG==='en' ? '' : '/'+LANG;
  var WA_NUM='41797899596';
  var bar=document.createElement('div');bar.id='vr-progress';

  var T={
    en:{member:'VRENT Club members: from {p} · save up to 30%',avail:'In stock: order today, delivered by {d}',wa:'Not sure? Ask us on WhatsApp. We reply fast',wamsg:'Hi VRENT! I have a question about ',gww:'Goes well with',clubT:'VRENT Club',clubS:'Save up to 30% on this rental',clubP:'from CHF 59/mo',from:'from',week:'/week',rent:'Rent now',mcta:['Get a price in a minute','/pages/vr-corner']},
    de:{member:'VRENT Club Mitglieder: ab {p} · bis zu 30% sparen',avail:'Auf Lager: heute bestellt, geliefert bis {d}',wa:'Unsicher? Fragen Sie uns auf WhatsApp, wir antworten schnell',wamsg:'Hallo VRENT! Ich habe eine Frage zu ',gww:'Passt gut dazu',clubT:'VRENT Club',clubS:'Bis zu 30% auf diese Miete sparen',clubP:'ab CHF 59/Mt.',from:'ab',week:'/Woche',rent:'Jetzt mieten',mcta:['Preis in einer Minute erhalten','/de/pages/vr-corner']},
    fr:{member:'Membres VRENT Club : dès {p} · jusqu’à −30%',avail:'En stock : commandé aujourd’hui, livré d’ici {d}',wa:'Pas sûr ? Écrivez-nous sur WhatsApp, réponse rapide',wamsg:'Bonjour VRENT ! J’ai une question sur ',gww:'Se combine bien avec',clubT:'VRENT Club',clubS:'Jusqu’à 30% d’économie sur cette location',clubP:'dès CHF 59/mois',from:'dès',week:'/semaine',rent:'Louer',mcta:['Obtenez un prix en une minute','/fr/pages/vr-corner']},
    it:{member:'Membri VRENT Club: da {p} · fino al 30% di sconto',avail:'Disponibile: ordina oggi, consegna entro {d}',wa:'Hai dubbi? Scrivici su WhatsApp, rispondiamo subito',wamsg:'Ciao VRENT! Ho una domanda su ',gww:'Si abbina bene con',clubT:'VRENT Club',clubS:'Risparmia fino al 30% su questo noleggio',clubP:'da CHF 59/mese',from:'da',week:'/settimana',rent:'Noleggia ora',mcta:['Ricevi un prezzo in un minuto','/it/pages/vr-corner']}
  }[LANG];

  function init(){
    document.body.appendChild(bar);
    var ticking=false;
    function onScroll(){if(!ticking){requestAnimationFrame(function(){var h=document.documentElement;var sc=h.scrollTop||document.body.scrollTop;var max=h.scrollHeight-h.clientHeight;bar.style.width=(max>0?(sc/max*100):0)+'%';document.body.classList.toggle('vr-scrolled',sc>8);ticking=false});ticking=true}}
    addEventListener('scroll',onScroll,{passive:true});onScroll();

    if(!window.matchMedia||!matchMedia('(prefers-reduced-motion: reduce)').matches){
      var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){io.unobserve(en.target);countUp(en.target)}})},{threshold:.6});
      document.querySelectorAll('.vhm-statcard-v,.vcl-card-big').forEach(function(el){io.observe(el)});
    }

    if(LANG!=='en'){
      var pref='/'+LANG;
      document.querySelectorAll('a[href^="/pages/"],a[href^="/collections/"],a[href^="/products/"],a[href^="/blogs/"],a[href^="/policies/"]').forEach(function(a){
        var h=a.getAttribute('href');
        if(h.indexOf(pref+'/')!==0){a.setAttribute('href',pref+h)}
      });
    }

    var p=location.pathname;
    var isProduct=/\/products\//.test(p);
    if(!isProduct && !/vr-corner|coin-vr|vr-angolo|\/cart/.test(p)){
      var d=document.createElement('div');d.id='vr-mcta';
      var a=document.createElement('a');a.href=T.mcta[1];a.textContent='⚡ '+T.mcta[0];d.appendChild(a);
      document.body.appendChild(d);
    }
    if(isProduct) productModule();
  }

  function countUp(el){
    var txt=el.textContent.trim();
    var m=txt.match(/^([^0-9]*)([0-9][0-9'.,]*)(.*)$/);if(!m)return;
    var num=parseFloat(m[2].replace(/[',]/g,''));
    if(!isFinite(num)||num<=1)return;
    var pre=m[1],suf=m[3],dur=1100,t0=null;
    function step(ts){if(!t0)t0=ts;var pr=Math.min(1,(ts-t0)/dur);var e=1-Math.pow(1-pr,3);el.textContent=pre+Math.round(num*e)+suf;if(pr<1)requestAnimationFrame(step)}
    requestAnimationFrame(step);
  }

  function xhrJson(url,cb){
    var x=new XMLHttpRequest();
    x.open('GET',url);
    x.onload=function(){try{cb(JSON.parse(x.responseText))}catch(e){cb(null)}};
    x.onerror=function(){cb(null)};
    x.send();
  }

  /* Product sales module — resilient to the Vue re-render: an ensure-loop
     recreates injected elements if the app wipes them and re-reads the price
     from whatever node currently exists. */
  function productModule(){
    var title='';
    var xsellData=null, xsellFetched=false;
    var handle=location.pathname.split('/products/')[1].split(/[/?#]/)[0];

    function currentPrice(){
      var m=document.querySelector('.product-details--form-wrapper .product-price-group .money');
      if(!m) return null;
      var v=parseFloat(m.textContent.replace(/[^0-9.]/g,''));
      return isFinite(v)?v:null;
    }

    function deliveryDay(){
      var now=new Date(), add=now.getHours()>=16?3:2, dt=new Date(now);
      while(add>0){dt.setDate(dt.getDate()+1);var w=dt.getDay();if(w!==0&&w!==6)add--}
      var locale={en:'en-GB',de:'de-CH',fr:'fr-CH',it:'it-CH'}[LANG];
      return dt.toLocaleDateString(locale,{weekday:'long'});
    }

    function ensure(){
      var form=document.querySelector('.product-details--form-wrapper');
      if(!form) return;
      if(!title){
        var tEl=document.querySelector('.product-details-product-title');
        if(tEl) title=tEl.textContent.trim();
      }
      var pg=form.querySelector('.product-price-group');
      var payWrap=form.querySelector('.paymentButtonsWrapper');
      var price=currentPrice();

      /* 1 — Club member from-price */
      var chip=document.getElementById('vr-member');
      if(!chip && pg){
        chip=document.createElement('a');
        chip.id='vr-member';
        chip.href=LP+'/pages/vrent-club';
        pg.parentNode.insertBefore(chip,pg.nextSibling);
      }
      if(chip){
        if(price!=null){
          chip.style.display='';
          chip.textContent='✦ '+T.member.replace('{p}','CHF '+Math.round(price*0.7));
        }else{
          chip.style.display='none';
        }
      }

      /* 2 — delivery-by line */
      if(chip && !document.getElementById('vr-avail')){
        var av=document.createElement('div');
        av.id='vr-avail';
        av.innerHTML='<i></i><span>'+T.avail.replace('{d}','<b>'+deliveryDay()+'</b>')+'</span>';
        chip.parentNode.insertBefore(av,chip.nextSibling);
      }

      /* 3 — WhatsApp ask-first */
      if(payWrap && !document.getElementById('vr-wa') && title){
        var wa=document.createElement('a');
        wa.id='vr-wa';
        wa.href='https://wa.me/'+WA_NUM+'?text='+encodeURIComponent(T.wamsg+title);
        wa.target='_blank'; wa.rel='noopener';
        wa.textContent='💬 '+T.wa;
        payWrap.parentNode.insertBefore(wa,payWrap.nextSibling);
      }

      /* 4 — Goes well with */
      var wrap=document.querySelector('.product-single-wrapper');
      if(wrap){
        if(!xsellFetched){
          xsellFetched=true;
          var pool=['meta-quest-3','insta360-x5-elevate-your-reality-in-360','xreal-one','ray-ban-meta-wayfarer-transitions'];
          var picks=pool.filter(function(h){return h!==handle}).slice(0,2);
          xsellData=[];
          picks.forEach(function(h){
            xhrJson('/products/'+h+'.js',function(pr){
              if(!pr||!pr.variants) return;
              var min=Math.min.apply(null,pr.variants.map(function(v){return v.price}));
              var img=(pr.featured_image||'').replace(/^\/\//,'https://');
              xsellData.push({h:h,t:pr.title,min:min,img:img});
              var old=document.getElementById('vr-xsell'); if(old) old.remove();
            });
          });
        }
        if(!document.getElementById('vr-xsell') && xsellData){
          var sec=document.createElement('div');
          sec.id='vr-xsell';
          var html='<h3>'+T.gww+'</h3><div class="vx-row">';
          xsellData.forEach(function(d){
            html+='<a class="vx" href="'+LP+'/products/'+d.h+'"><span class="vx-im"><img src="'+d.img+'&width=160" alt="" loading="lazy"></span><span><span class="vx-t">'+d.t+'</span><span class="vx-p">'+T.from+' CHF '+Math.round(d.min/100)+' '+T.week+'</span></span></a>';
          });
          html+='<a class="vx" href="'+LP+'/pages/vrent-club"><span class="vx-im vx-club">CLUB</span><span><span class="vx-t">'+T.clubT+'</span><span class="vx-s">'+T.clubS+'</span><span class="vx-p">'+T.clubP+'</span></span></a></div>';
          sec.innerHTML=html;
          wrap.parentNode.insertBefore(sec,wrap.nextSibling);
        }
      }

      /* 5 — sticky rent bar (attached to body — survives re-renders) */
      var rb=document.getElementById('vr-rentbar');
      if(!rb && payWrap && title){
        rb=document.createElement('div');
        rb.id='vr-rentbar';
        rb.innerHTML='<span class="vrb-t"></span><button type="button">'+T.rent+'</button>';
        document.body.appendChild(rb);
        rb.querySelector('button').addEventListener('click',function(){
          var w=document.querySelector('.product-details--form-wrapper .paymentButtonsWrapper');
          var btn=w&&w.querySelector('.btn,button');
          if(btn){btn.click()}else{document.querySelector('.product-details--form-wrapper').scrollIntoView({behavior:'smooth'})}
        });
        var seen=new IntersectionObserver(function(es){
          es.forEach(function(en){rb.classList.toggle('on',!en.isIntersecting&&en.boundingClientRect.top<0)});
        },{threshold:0});
        seen.observe(payWrap);
      }
      if(rb){
        var t=rb.querySelector('.vrb-t');
        t.textContent=title;
        if(price!=null){
          var ps=document.createElement('span');
          ps.className='vrb-p';
          ps.textContent='CHF '+price;
          t.appendChild(ps);
        }
      }
    }

    ensure();
    var tries=0;
    var iv=setInterval(function(){
      ensure();
      if(++tries>40) clearInterval(iv);
    },900);
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
})();
